/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { fetchAsJson } from '@modules/query/helpers'
import type {
  GetMinimalVersionResponse,
  GetProjectMetricsParams,
  GetProjectMetricsResponse,
} from '@modules/autoops-api/types'

export const getProjectMetrics = ({
  projectId,
  organizationId,
  region,
  from,
  to,
  metricTypes,
}: GetProjectMetricsParams) =>
  fetchAsJson<GetProjectMetricsResponse>(
    `/autoops/api/monitoring/serverless/v1/projects/${projectId}/metrics?region=${region}`,
    {
      method: 'POST',
      headers: {
        organizationId,
        deploymentId: projectId,
      },
      body: JSON.stringify({
        from,
        to,
        metric_types: metricTypes,
        level: 'project',
      }),
    },
  )

export const getMinimalVersion = () =>
  fetchAsJson<GetMinimalVersionResponse>('/autoops/ams/api/v1/agents/minimal-version')
